import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField
} from '@material-ui/core';
import axios from 'axios';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import { NotificationManager } from 'react-notifications';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
class SosList extends React.Component {
    constructor() {
        super();
        this.state = {
            Name1: "",
            Name2: "",
            Name3: "",
            Contact1: "",
            Contact2: "",
            Contact3: "",
            contacts: [],
            location: "",
            message: "",
            sosData: []

        }
    }
    componentDidMount() {
        this.getSosDetails()
    }

    getSosDetails = () => {
        var authToken = getCookies();

        try {
            axios({
                method: 'get',
                url: `${SERVER_URL}/sos/view`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                if (resJson.data.status == "OK") {
                    var lengthOfContacts = resJson.data.data.contact.length;
                    if (lengthOfContacts == 0) {
                        this.setState({
                            sosData: resJson.data.data,
                            Contact1: '',
                            Contact2: '',
                            Contact3: '',
                            Name1: '',
                            Name2: '',
                            Name3: '',
                            message: resJson.data.data.message
                        })
                    } else if (lengthOfContacts == 1) {
                        this.setState({
                            sosData: resJson.data.data,
                            Contact1: resJson.data.data.contact[0],
                            Contact2: '',
                            Contact3: '',
                            Name1: resJson.data.data.name[0],
                            Name2: '',
                            Name3: '',
                            message: resJson.data.data.message
                        })
                    } else if (lengthOfContacts == 2) {
                        this.setState({
                            sosData: resJson.data.data,
                            Contact1: resJson.data.data.contact[0],
                            Contact2: resJson.data.data.contact[1],
                            Contact3: '',
                            Name1: resJson.data.data.name[0],
                            Name2: resJson.data.data.name[1],
                            Name3: '',
                            message: resJson.data.data.message
                        })
                    } else if (lengthOfContacts == 3) {
                        this.setState({
                            sosData: resJson.data.data,
                            Contact1: resJson.data.data.contact[0],
                            Contact2: resJson.data.data.contact[1],
                            Contact3: resJson.data.data.contact[2],
                            Name1: resJson.data.data.name[0],
                            Name2: resJson.data.data.name[1],
                            Name3: resJson.data.data.name[2],
                            message: resJson.data.data.message
                        })
                    } else {
                        this.setState({
                            sosData: resJson.data.data,
                            Contact1: '',
                            Contact2: '',
                            Contact3: '',
                            Name1: '',
                            Name2: '',
                            Name3: '',
                            message: resJson.data.data.message
                        })
                    }

                }
            })
        } catch (e) {

            return e;
        }
        try {
            axios({
                method: 'get',
                url: `${SERVER_URL}/sos/view`,
                headers: { 'x-auth-token': authToken }
            }).then(resJson => {
                if (resJson.data.status == "OK") {
                    this.setState({
                        sosData: resJson.data.data,
                        Contact1: resJson.data.data.contact[0],
                        Contact2: resJson.data.data.contact[1],
                        Contact3: resJson.data.data.contact[2],
                        message: resJson.data.data.message
                    })
                }
            })
        } catch (e) {
            NotificationManager.error(e)
        }
    }
    checkPhoneNumber = (phone) => {
        var length = phone.replace(/\s/g, "").length;

        if (length >= 9 && length <= 14) {
            return true;
        }
        return false;
    }

    sosAction = () => {
        var authToken = getCookies();
        const { Contact1, Contact2, Contact3, message, contacts, Name1, Name2, Name3 } = this.state

        if (Contact1 == "" && Contact2 == "" && Contact3 == "") {
            NotificationManager.error("Oops!", "Enter atleast one contact")
        } else {
            var validation = true;
            if (Contact1.trim() != "") {
                if (this.state.Name1.trim() == '') {
                    validation = false;
                    this.setState({
                        Name1Error: "Please enter name 1"
                    })
                }
                if (!this.checkPhoneNumber(Contact1.trim())) {
                    validation = false;
                    this.setState({
                        Contact1Error: "Please enter valid contact 1"
                    })
                }
            }
            if (Contact2.trim() != "") {
                if (this.state.Name2.trim() == '') {
                    validation = false;
                    this.setState({
                        Name2Error: "Please enter name 2"
                    })
                }
                if (!this.checkPhoneNumber(Contact2.trim())) {
                    validation = false;
                    this.setState({
                        Contact2Error: "Please enter valid contact 2"
                    })
                }
            }
            if (Contact3.trim() != "") {
                if (this.state.Name3.trim() == '') {
                    validation = false;
                    this.setState({
                        Name3Error: "Please enter name 2"
                    })
                }
                if (!this.checkPhoneNumber(Contact3.trim())) {
                    validation = false;
                    this.setState({
                        Contact3Error: "Please enter valid contact 3"
                    })
                }
            }
            if (message.trim() == "") {
                validation = false;
                this.setState({
                    messageError: "Please enter message"
                })
                NotificationManager.error("Oops!", "Please enter message")

            }

            if (validation) {
                try {
                    axios({
                        method: 'post',
                        url: `${SERVER_URL}/sos/create`,
                        data: {
                            contact1: Contact1.trim(),
                            contact2: Contact2.trim(),
                            contact3: Contact3.trim(),
                            name1: Name1.trim(),
                            name2: Name2.trim(),
                            name3: Name3.trim(),
                            message: message,
                            latitude: String(this.props.userData.location.latitude),
                            longitude: String(this.props.userData.location.longitude)
                        },
                        headers: { 'x-auth-token': authToken }

                    }).then(resJson => {
                        if (resJson.data.status == "OK") {
                            NotificationManager.success("Success", resJson.data.message)
                        } else if (resJson.data.status == "NOK") {
                            NotificationManager.error("Oops!", resJson.data.message)
                        } else {
                            NotificationManager.error("Oops!", resJson.data.message)
                        }

                    })
                } catch (e) {
                    return e;
                }
            }
        }
    }

    render() {
        return (
            <div style={{ width: "100%" }} className="custom-input-text">
                <div className="mt-1 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Name"
                            name="Name1"
                            label="Contact #1"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Name1}
                            onChange={event => {
                                this.setState({
                                    Name1:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-1 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Mobile"
                            name="Contact1"
			    type="number"
                            label="Mobile #1"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Contact1}
                            onChange={event => {
                                this.setState({
                                    Contact1:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-1 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Name"
                            name="Name2"
                            label="Contact #2"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Name2}
                            onChange={event => {
                                this.setState({
                                    Name2:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-3 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Mobile"
                            name="Contact2"
			    type="number"
                            label="Mobile #2"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Contact2}
                            onChange={event => {
                                this.setState({
                                    Contact2:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-1 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Name"
                            name="Name3"
                            label="Contact #3"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Name3}
                            onChange={event => {
                                this.setState({
                                    Name3:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-3 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Enter Mobile"
                            name="Contact3"
		            type="number"
                            label="Mobile #3"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.Contact3}
                            onChange={event => {
                                this.setState({
                                    Contact3:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="mt-3 mb-1 main-panel cpn-pag-form">
                    <form className="form-new">
                        <TextField
                            id="standard-full-width"
                            placeholder="Message"
                            name="Message"
                            label="Message"
                            fullWidth
                            className="login-form-textfield"
                            margin="normal"
                            value={this.state.message}
                            onChange={event => {
                                this.setState({
                                    message:
                                        event
                                            .target
                                            .value
                                });
                            }}
                        />
                    </form>
                </div>
                <div className="d-flex justify-content-center">

                    <button className="custom-button" >
                        <i class="material-icons left">my_location</i> My Current Location</button>
                </div>
                <div className="d-flex justify-content-center">
                    <button /* style={{ width: "26%", marginLeft: "37%", height: 50 }} */
                        className="custom-button"
                        onClick={() => {
                            this.sosAction()
                        }}
                    >SUBMIT</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(SosList);



// WEBPACK FOOTER //
// ./src/components/Customer/SosList.jsx